import React from "react";
import { Box } from "@mui/material";
import { colors } from "../../../styles/colors";

interface MapBottomBarProps {
  children: React.ReactNode;
}

/**
 * Leiste unten-mittig über der Karte. Weiße Fläche eng am Inhalt, damit sie als
 * Hintergrund des Buttons wirkt und nicht als eigenes Panel darum herum.
 */
const MapBottomBar: React.FC<MapBottomBarProps> = ({ children }) => (
  <Box
    sx={{
      position: "absolute",
      bottom: 16,
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 1000,
      display: "flex",
      alignItems: "center",
      gap: 2,
      whiteSpace: "nowrap",
      backgroundColor: colors.background.paper,
      borderRadius: "8px",
    }}
  >
    {children}
  </Box>
);

export default MapBottomBar;
